/**
 * Version-family timeline action — the data behind `/…/version-history`.
 *
 * Goes through Volto's api middleware rather than a bare `fetch` for the same
 * reason the typeahead does: the middleware is what knows the API base, which
 * differs between the server (internalApiPath) and the browser. A hand-rolled
 * fetch would have to re-derive that and would be wrong on one of the two.
 *
 * The backend service is `@family-timeline`, registered on any Dexterity
 * content object, and it returns the SAME family whichever member is asked —
 * so the path here is simply the document the reader came from.
 */
export const GET_FAMILY_TIMELINE = 'GET_FAMILY_TIMELINE';

/**
 * @param {string} path app-relative path of ANY member of the family
 *                      (e.g. `/documents/doe-o-4251e-...`)
 */
export function getFamilyTimeline(path) {
  return {
    type: GET_FAMILY_TIMELINE,
    request: { op: 'get', path: `${path}/@family-timeline` },
    // Carried to the reducer so a response for a document the reader has
    // already navigated away from cannot overwrite the current one.
    path,
  };
}

export default getFamilyTimeline;
